export const fmtBs = (v) => `Bs. ${(v || 0).toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const COLORS = ['#EF4444', '#F59E0B', '#3B82F6', '#8B5CF6'];

export const CHART_COLORS_EMERALD = ["#059669", "#10b981", "#34d399", "#6ee7b7", "#a7f3d0", "#d1fae5", "#047857", "#065f46"];

export const CHART_COLORS_SKY = ["#0284c7", "#0ea5e9", "#38bdf8", "#7dd3fc", "#bae6fd", "#e0f2fe", "#0369a1", "#075985"];

export const CHART_COLORS_ROSE = ["#e11d48", "#f43f5e", "#fb7185", "#fda4af", "#fecdd3", "#fff1f2", "#be123c", "#9f1239"];
